module.exports = __webpack_public_path__ + "static/Juggl-title-transparent-d34f03362e4299288a3a80d04217897c.png";